import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE, SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE } from './actionTypes';
import authService from '../../services/authService';

// Sign-up
export const signUpRequest = () => ({
  type: SIGNUP_REQUEST,
});

export const signUpSuccess = (user) => ({
  type: SIGNUP_SUCCESS,
  payload: user,
});

export const signUpFailure = (error) => ({
  type: SIGNUP_FAILURE,
  payload: error,
});

export const signUpUser = (formData) => {
  return async (dispatch) => {
    dispatch(signUpRequest());
    try {
      const response = await authService.signUp(formData); 
      if (response.data.status) {
        // window.location="/"
          }
      dispatch(signUpSuccess(response.data));
    } catch (error) {
      dispatch(signUpFailure(error.response.data || 'Sign-up failed!'));
    }
  };
};



export const signInUser = (formData) => {
  return async (dispatch) => {
    dispatch({ type: SIGN_IN_REQUEST });
    try {
      const response = await authService.signIn(formData);  
      if (!response.data.success) {
        throw new Error('Sign-in failed. Please check your credentials.');
      }

      dispatch({ type: SIGN_IN_SUCCESS, payload: response.data });
      const user = response.data.data;
      localStorage.setItem("userData", JSON.stringify(user)); 
      return Promise.resolve(response.data.data);
      
    } catch (error) {
      dispatch({ type: SIGN_IN_FAILURE, payload: error.message });
      return Promise.reject(error);
    }
  };
};



export const loadUserFromStorage = () => {
  return (dispatch) => {
    const userData = localStorage.getItem("userData");
    
    if (userData!="undefined") {
      const parsedData = JSON.parse(userData);
      dispatch({
        type: SIGN_IN_SUCCESS,
        payload: { data: parsedData },
      });
    }
  };
};
